import { render } from "./Vertical.vue?vue&type=template&id=2b8220de"
import script from "./Vertical.vue?vue&type=script&lang=ts"
export * from "./Vertical.vue?vue&type=script&lang=ts"
script.render = render

export default script